import { useSelector } from 'react-redux';
import { getCurrentAppLn } from 'src/selectors/app';
import { Language } from 'src/types/types';

const useCurrentAppLn = (): Language => useSelector(getCurrentAppLn);

export default useCurrentAppLn;
